var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('LazyImg',{staticClass:"responsive-image",attrs:{"description":_vm.description,"url":_vm.url,"egar":_vm.egar}}):_c('div',{staticClass:"is-empty"})
}
var staticRenderFns = []

export { render, staticRenderFns }